<template>
  <div no-body class="lku-koran-polaharga">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2">
      <span style="color:blue;">Loading data ...</span>
    </b-row>
    <b-row v-else>
      <b-col lg="9">
        <b-form-group
          style="margin-bottom:-4px !important;"
          horizontal
          label="Filter"
          label-cols="1"
        >
          <b-row>
            <b-col class="pr-1" cols="3">
              <b-form-input
                v-model="tblData.CustCode"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Code"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.CustName"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Cust Name"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.collector_name"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Kolektor"
              ></b-form-input>
            </b-col>
            <b-col class="pl-1 pr-1" cols="3">
              <b-form-input
                v-model="tblData.salesae_name"
                @keyup.13.native="refresh()"
                size="sm"
                placeholder="Sales"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
      <b-col lg="3">
        <b-form-group style="margin-bottom:-4px !important;" horizontal>
          <b-row>
            <b-button class="btn btn-success mr-1" @click="refresh()" size="sm">
              <i class="fa fa-search"></i> Search
            </b-button>
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()" size="sm">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblKoranCust"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      :busy="busyTbl"
      @row-clicked="selectItem"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Sedang mengunduh data...</strong>
        </div>
      </template>
      <template
        v-slot:cell(collector)="data"
      >{{data.item.collector_code}} | {{data.item.collector_name}}</template>
      <template v-slot:cell(sales)="data">{{data.item.salesae_name}}</template>
      <template
        slot="requestdate"
        slot-scope="data"
      >{{ data.item.requestdate | moment("DD MMM YYYY") }}</template>
      <template
        slot="quantity"
        slot-scope="data"
      >{{data.item.quantity}} &nbsp; {{data.item.unitsize}}</template>
      <template v-slot:cell(nilai)="data">
        <span v-if="(data.item.nilai)">{{data.item.matauang}} &nbsp;{{data.item.nilai|numFormat}}</span>
      </template>
      <template v-slot:cell(jasa)="data">
        <span v-if="(data.item.jasa)">Service</span>
        <span v-else>Material</span>
      </template>
    </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
.lku-adv {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import pascabayar from "../../apis/koran_pesanan_pascabayar";

export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: "CustCode",
          thStyle: "width:50px",
          label: "Kode Pelanggan",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Pelanggan",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "DeliveryAddr",
          label: "Alamat Kirim",
          thStyle: "width:250px"
        },
        {
          key: "PhoneNo",
          label: "Phone/Fax",
          thStyle: "width:150px"
        },
        {
          key: "collector",
          label: "Kode | Name Collector",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "sales",
          label: "Sales (AE)",
          thStyle: "width:150px",
          sortable: true
        }
      ],
      busyTbl: false,
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: null,
        sortDesc: false,
        outstand: "1"
      },
      lkuLoading: false
    };
  },
  props: ["bill2group"],
  created: async function() {
      this.tblData.bill2group=this.bill2group || '';
  },

  methods: {
    data: async function() {
      this.busyTbl = true;
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await pascabayar.list(this.tblData);
      this.busyTbl = false;
      return list;
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.name = "";
      this.tblData.code = "";
      this.tblData.collector_name = "";
      this.tblData.salesae_name = "";
      this.refresh();
    },
    refresh: async function() {
      this.$refs.tblKoranCust.refresh();
    }
  }
};
</script>
